import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Table, Input} from "reactstrap";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import useLeads from "../../Hooks/useLeads";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import LeadFilters from "../../components/FbLeadgen/LeadFilters";
import useStages from "../../Hooks/useStages";
import useProjects from "../../Hooks/useProjects";
import useFbForms from "../../Hooks/useFbForms";
import useFbPages from "../../Hooks/useFbPages";
import AppLoader from "../../components/Common/AppLoader";
import MobileLeadCards from "../../components/FbLeadgen/MobileLeadCards";

const UserLeads = () => {
  const location=useLocation();
  const { userId }=useParams();
  const [refresh,setRefresh]=useState(false);  
  const isMyLeads= location.pathname==="/my-leads";
  const navigate = useNavigate();
  // const userId = searchParams.get("userId");
  const [isMobile,setIsMobile]=useState(window.innerWidth<=768);

  useEffect(()=>{
    const handleResize=()=>setIsMobile(window.innerWidth<=768);

    window.addEventListener("resize",handleResize);

    return ()=>window.removeEventListener("resize",handleResize);
  },[]);

  const [filters, setFilters] = useState({
    search: "",
    source: "all",
    page: 1,
    limit: 20,
    stage: "",
    projectId: "",
    formId: "",
    pageId: "",
    sortBy: "createdTime",
    sortOrder: "desc",
  });

  const { leads, loading, pagination, fetchLeadsByUserId,fetchMyLeads,userName } = useLeads();

  const [filterModal, setFilterModal] = useState(false);

  const { stages = [] } = useStages({ limit: 1000 });
  const { projects = [] } = useProjects({ limit: 1000 });
  const { forms = [] } = useFbForms({ limit: 1000 });
  const { pages = [] } = useFbPages();

  const handleChange = (name, value) =>
    setFilters((p) => ({ ...p, [name]: value, page: 1 }));

  const handleReset = () =>
    setFilters({
      search: "",
      source: "all",
      page: 1,
      limit: 20,
      stage: "",
      projectId: "",
      formId: "",
      pageId: "",
      sortBy: "createdTime",
      sortOrder: "desc",
    });

    const buildQuery=()=>{
      const query=new URLSearchParams();

      Object.entries(filters).forEach(([key,val])=>{
        if(val){
          query.append(key,val);
        }
      });

      return query.toString();
    };

  useEffect(()=>{
      if(isMyLeads){
        fetchMyLeads(filters);
      }else if(userId){
        fetchLeadsByUserId( userId, buildQuery() );
      }
    },[ isMyLeads, userId, JSON.stringify(filters), refresh]);

    const getLeadDetailsRoute = (lead) => `/lead-details/${lead.source}/${lead._id}`;

    const formatDateTime = (date) => {
      if (!date) return { date: "-", time: "-" };

      const d = new Date(date);

      return {
        date: d.toLocaleDateString("en-IN", {
          timeZone: "Asia/Kolkata",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        time: d.toLocaleTimeString("en-IN", {
          timeZone: "Asia/Kolkata",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      };
    };
  return (
    <div className="page-content">
      <Breadcrumbs title="Leads" breadcrumbItem={ isMyLeads ? "My Leads" : `${userName || "User"}'s Leads` } />

      <div className="card p-3 mb-3">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div style={{ minWidth: "260px", maxWidth: "400px", width: "100%" }}>
            <div className="position-relative">
              <i
                className="mdi mdi-magnify"
                style={{
                  position: "absolute",
                  top: "10px",
                  left: "12px",
                  fontSize: "16px",
                  color: "#74788d",
                }}
              />
              <Input
                placeholder="Search name / email / phone..."
                value={filters.search}
                style={{ paddingLeft: "35px" }}
                onChange={(e) => handleChange("search", e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap">
            <div
              className="px-2 py-1 rounded small fw-semibold"
              style={{
                background: "#f8f9fa",
                border: "1px solid #e9ebec",
                minWidth: "70px",
                textAlign: "center",
              }}
            >
              Leads : {pagination?.total || 0}
            </div>

            <Input
              type="select"
              value={filters.limit}
              style={{ width: "90px" }}
              onChange={(e) => handleChange("limit", e.target.value)}
            >
              {[10, 20, 50, 100].map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </Input>

            <Button color="primary" onClick={() => setFilterModal(true)}>
              <i className="mdi mdi-filter-variant" />
            </Button>

            <Button color="light" onClick={()=>{ handleReset(); setRefresh(p=>!p); }}>
              <i className="mdi mdi-refresh" />
            </Button>
          </div>
        </div>
      </div>

      <Card>
        <CardBody>
          <div className="mb-3">
            <h4 className="mb-0"> { isMyLeads ? "My Leads" : "Assigned User Leads" } </h4>
          </div>

          {
            isMobile ? (
              <MobileLeadCards
                leads={leads}
                loading={loading}
                navigate={navigate}
                selectedLeadIds={[]}
                handleLeadSelect={()=>{}}
                hideCheckbox
              />
            ) : (
              <Table className="table align-middle table-hover" style={{fontSize:"12px"}}>
                <thead className="table-light">
                  <tr>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Project</th>
                    <th>Stage</th>
                    <th>Remark</th>
                    <th>Came Date</th>
                    <th>Added Date</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="p-0">
                        <AppLoader compact />
                      </td>
                    </tr>
                  ) : leads?.length ? (
                    leads.map((lead)=>(
                      <tr
                        key={lead._id}
                        onClick={()=>navigate(getLeadDetailsRoute(lead))}
                        style={{cursor:"pointer"}}
                      >
                        <td>{lead.name || "-"} <br/>
                          {
                            lead.source === "google" ? (
                              <div className="d-flex align-items-center gap-1 fw-semibold text-danger">
                                <i className="mdi mdi-google" />
                                Google
                              </div>
                            ) : lead.source === "facebook" ? (
                              <>
                                <div className="d-flex align-items-center gap-1 fw-semibold text-info mb-1">
                                  <i className="mdi mdi-facebook" />
                                  Facebook
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-center gap-1 fw-semibold text-success mb-1">
                                <i className="mdi mdi-account-plus-outline" />
                                {lead.source === "generic" ? "Generic Lead" : String(lead.source).toUpperCase()}
                              </div>
                            )
                          }
                        </td>

                        <td>
                          {lead.email || "-"}
                          <br/>
                          {lead.phone || "-"}
                        </td>

                        <td>
                          {lead.projectName || lead.projectId?.projectName || "-"}
                        </td>
                        <td>
                          <span className="badge bg-primary">
                            {lead.stage || "-"}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-warning text-dark">
                            {lead.remark || "-"}
                          </span>
                        </td>

                         <td onClick={()=>navigate(getLeadDetailsRoute(lead))} style={{ minWidth:"140px" }} >
                          { lead.createdTime ? (() => {
                                  const dt = formatDateTime(lead.createdTime);
                                  return (
                                    <>
                                      <div className="fw-semibold">{dt.date}</div>
                                      <small className="text-muted">
                                        <i className="mdi mdi-clock-outline me-1"/>
                                        {dt.time}
                                      </small>
                                    </>
                                  );
                                })()
                              : "-"
                          }
                        </td>
                        <td onClick={()=>navigate(getLeadDetailsRoute(lead))} style={{ minWidth:"140px" }} >
                          { lead.syncedAt ? (() => {
                                  const dt = formatDateTime(lead.syncedAt);
                                  return (
                                    <>
                                      <div className="fw-semibold">{dt.date}</div>
                                      <small className="text-muted">
                                        <i className="mdi mdi-clock-outline me-1"/>
                                        {dt.time}
                                      </small>
                                    </>
                                  );
                                })()
                              : "-"
                          }
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Leads Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )
          }

          <LeadFilters
            isOpen={filterModal}
            toggle={() => setFilterModal(false)}
            filters={filters}
            setFilters={setFilters}
            stages={stages}
            projects={projects}
            forms={forms}
            pages={pages}
            hideAssignedToFilter={true}
          />

          <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
            <Button
              size="sm"
              color="light"
              disabled={pagination?.page <= 1}
              onClick={() => setFilters((p) => ({ ...p, page: p.page - 1 }))}
            >
              <i className="mdi mdi-chevron-left" />
            </Button>

            <span className="small">
              Page {pagination?.page || 1} / {pagination?.totalPages || 1}
            </span>

            <Button
              size="sm"
              color="light"
              disabled={pagination?.page >= pagination?.totalPages}
              onClick={() => setFilters((p) => ({ ...p, page: p.page + 1 }))}
            >
              <i className="mdi mdi-chevron-right" />
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default UserLeads;
